import { TFunction } from 'i18next';
import moment from 'moment';
import { DATE_FORMAT_DEFAUT } from 'Config';

export const formatAdditionalDataValue = (
    value: string | null | undefined,
    type: string,
    t: TFunction
): string => {
    if (value === null || value === undefined || value === '') return '-';

    switch (type) {
        case 'TEXT':
            return value;
        case 'NUMBER':
            return value;
        case 'DATE':
            return moment(value).isValid() ? moment(value).format(DATE_FORMAT_DEFAUT) : '-';
        case 'BOOLEAN':
            return value === 'true' ? (t('common.yes') as string) : (t('common.no') as string);
        default:
            return value;
    }
};
